import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    key: "auto",
    title: "Auto Insurance",
    desc: "Smart coverage for daily drivers, classics, and full garages.",
    image:
      "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80",
    tag: "01",
  },
  {
    key: "home",
    title: "Home Insurance",
    desc: "Protection for the place that holds everything that matters.",
    image:
      "https://images.unsplash.com/photo-1490815809234-616a7ee1033d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxibGFjayUyMGFuZCUyMHdoaXRlJTIwbWluaW1hbCUyMG1vZGVybiUyMGhvdXNlfGVufDB8fHx8MTc3NzAwNTkyM3ww&ixlib=rb-4.1.0&q=85",
    tag: "02",
  },
  {
    key: "commercial",
    title: "Commercial Insurance",
    desc: "Coverage engineered around how your business actually operates.",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
    tag: "03",
  },
  {
    key: "life",
    title: "Life Insurance",
    desc: "Long-view planning that turns care into a tangible legacy.",
    image:
      "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&q=80",
    tag: "04",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="section-services"
      className="bg-[#fafafa] border-t border-neutral-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-36">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14" data-reveal>
          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-6">
              Coverage
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] text-black leading-[1.02]">
              Built for every
              <br />
              <span className="italic font-medium">corner of your life.</span>
            </h2>
          </div>
          <p className="max-w-md text-neutral-600 leading-relaxed">
            Four pillars. Dozens of carriers. One advisor who makes sure every
            detail is accounted for — so nothing important is ever left
            exposed.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-reveal-group>
          {SERVICES.map((s, i) => (
            <article
              key={s.key}
              data-testid={`service-card-${s.key}`}
              data-reveal-child
              data-reveal-delay={i + 1}
              className="group card-lift relative flex flex-col bg-white border border-neutral-200 rounded-2xl overflow-hidden"
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-neutral-100">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover grayscale transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:scale-[1.04]"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 text-white text-xs tracking-[0.24em] uppercase">
                  {s.tag}
                </div>
              </div>
              <div className="p-6 md:p-7 flex flex-col gap-3 flex-1">
                <h3 className="font-display text-xl md:text-2xl font-semibold tracking-[-0.01em] text-black">
                  {s.title}
                </h3>
                <p className="text-[15px] text-neutral-600 leading-relaxed">
                  {s.desc}
                </p>
                <Link
                  to="/quote"
                  data-testid={`service-cta-${s.key}`}
                  className="mt-auto inline-flex items-center gap-1.5 text-sm font-medium text-black group/link"
                >
                  <span className="border-b border-black/50 group-hover/link:border-black pb-0.5 transition-colors">
                    Get a quote
                  </span>
                  <ArrowUpRight
                    size={16}
                    className="transition-transform group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5"
                  />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
